(() => {
  const script = document.currentScript;
  const projectKey = script?.dataset.projectKey?.trim();
  const apiHost = script?.dataset.apiHost;
  const assetHosts = {
    'https://eu.i.posthog.com': 'https://eu-assets.i.posthog.com',
    'https://us.i.posthog.com': 'https://us-assets.i.posthog.com',
  };

  if (!projectKey || projectKey === 'phc_REPLACE_WITH_YOUR_PROJECT_KEY' || !assetHosts[apiHost]) return;
  if (window.Shopify?.designMode || window.calicoPosthogStarted || window.posthog) return;
  window.calicoPosthogStarted = true;

  let loading = false;
  let sdkAvailable = false;
  let client;
  let capturing = false;
  let pageviewCaptured = false;

  function analyticsAllowed() {
    return window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true;
  }

  function syncConsent() {
    const allowed = analyticsAllowed();

    if (client) {
      if (allowed && !capturing) {
        client.opt_in_capturing();
        capturing = true;
        if (!pageviewCaptured) {
          client.capture('$pageview');
          pageviewCaptured = true;
        }
      } else if (!allowed) {
        client.opt_out_capturing();
        capturing = false;
      }
      return;
    }

    if (!allowed || loading) return;
    if (!sdkAvailable) {
      loading = true;
      const sdk = document.createElement('script');
      sdk.src = `${assetHosts[apiHost]}/static/array.js`;
      sdk.async = true;
      sdk.crossOrigin = 'anonymous';
      sdk.onload = () => {
        loading = false;
        sdkAvailable = true;
        syncConsent();
      };
      sdk.onerror = () => {
        loading = false;
        sdk.remove();
      };
      document.head.appendChild(sdk);
      return;
    }

    if (typeof window.posthog?.init !== 'function') return;
    loading = true;
    window.posthog.init(projectKey, {
      api_host: apiHost,
      autocapture: true,
      capture_pageview: false,
      capture_pageleave: true,
      capture_dead_clicks: true,
      enable_heatmaps: true,
      capture_exceptions: true,
      capture_performance: { web_vitals: true, network_timing: false },
      person_profiles: 'identified_only',
      disable_session_recording: script.dataset.sessionReplay !== 'true',
      session_recording: {
        maskAllInputs: true,
        maskTextSelector: '*',
        blockSelector: 'input[type="hidden"], input[type="file"], .shopify-challenge__container',
        recordBody: false,
        recordHeaders: false,
      },
      enable_recording_console_log: false,
      disable_surveys: script.dataset.surveys !== 'true',
      opt_out_capturing_by_default: true,
      loaded: (posthog) => {
        client = posthog;
        loading = false;
        syncConsent();
      },
    });
  }

  document.addEventListener('visitorConsentCollected', syncConsent);
  if (window.Shopify?.customerPrivacy) {
    syncConsent();
  } else if (typeof window.Shopify?.loadFeatures === 'function') {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (error) => {
      if (!error) syncConsent();
    });
  }
})();
